var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
__name(_typeof, "_typeof");
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
__name(ownKeys, "ownKeys");
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
__name(_objectSpread, "_objectSpread");
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
__name(_defineProperty, "_defineProperty");
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
__name(_toPropertyKey, "_toPropertyKey");
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
__name(_toPrimitive, "_toPrimitive");
import React from "react";
import classNames from "classnames";
import { wrapperCls, wrapperNoPaddingCls, wrapperHorizontalPaddingXs, wrapperHorizontalPaddingSm, wrapperHorizontalPaddingMd, wrapperHorizontalPaddingLg, wrapperHorizontalPaddingXl, wrapperNarrowXsCls, wrapperWideXsCls, wrapperFullWidthXsCls, wrapperNarrowSmCls, wrapperWideSmCls, wrapperFullWidthSmCls, wrapperNarrowMdCls, wrapperWideMdCls, wrapperFullWidthMdCls, wrapperNarrowLgCls, wrapperWideLgCls, wrapperFullWidthLgCls, wrapperNarrowXlCls, wrapperWideXlCls, wrapperFullWidthXlCls } from "./Wrapper.less";
var DEFAULT_SIZES = {
  xs: "wide",
  sm: "wide",
  md: "wide",
  lg: "wide",
  xl: "wide"
};
var DEFAULT_SIZE_KEYS = Object.keys(DEFAULT_SIZES);
var SIZE_TO_CLASSNAME = {
  xs: {
    narrow: wrapperNarrowXsCls,
    wide: wrapperWideXsCls,
    fullWidth: wrapperFullWidthXsCls
  },
  sm: {
    narrow: wrapperNarrowSmCls,
    wide: wrapperWideSmCls,
    fullWidth: wrapperFullWidthSmCls
  },
  md: {
    narrow: wrapperNarrowMdCls,
    wide: wrapperWideMdCls,
    fullWidth: wrapperFullWidthMdCls
  },
  lg: {
    narrow: wrapperNarrowLgCls,
    wide: wrapperWideLgCls,
    fullWidth: wrapperFullWidthLgCls
  },
  xl: {
    narrow: wrapperNarrowXlCls,
    wide: wrapperWideXlCls,
    fullWidth: wrapperFullWidthXlCls
  }
};
var wrapperPaddings = {
  xs: parseInt(wrapperHorizontalPaddingXs, 10),
  sm: parseInt(wrapperHorizontalPaddingSm, 10),
  md: parseInt(wrapperHorizontalPaddingMd, 10),
  lg: parseInt(wrapperHorizontalPaddingLg, 10),
  xl: parseInt(wrapperHorizontalPaddingXl, 10)
};
var Wrapper = /* @__PURE__ */ __name(function Wrapper2(_ref) {
  var _ref$nodeType = _ref.nodeType, ComponentType = _ref$nodeType === void 0 ? "div" : _ref$nodeType, _ref$sizes = _ref.sizes, sizes = _ref$sizes === void 0 ? DEFAULT_SIZES : _ref$sizes, _ref$noPadding = _ref.noPadding, noPadding = _ref$noPadding === void 0 ? false : _ref$noPadding, className = _ref.className, _ref$children = _ref.children, children = _ref$children === void 0 ? null : _ref$children;
  var combinedSizes = typeof sizes === "string" ? DEFAULT_SIZE_KEYS.reduce(function(res, i) {
    res[i] = sizes;
    return res;
  }, {}) : _objectSpread(_objectSpread({}, DEFAULT_SIZES), sizes);
  var sizeClassName = Object.keys(combinedSizes).map(function(i) {
    return SIZE_TO_CLASSNAME[i] && SIZE_TO_CLASSNAME[i][combinedSizes[i]];
  });
  return /* @__PURE__ */ React.createElement(ComponentType, {
    className: classNames(wrapperCls, className, sizeClassName, _defineProperty({}, wrapperNoPaddingCls, noPadding))
  }, children);
}, "Wrapper");
export {
  Wrapper,
  wrapperCls,
  wrapperPaddings
};
